import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueRouter from "vue-router";
import router from "./router/index.js";
import App from "./App.vue";
import less from "less";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import "./assets/less/common.less";
import "./assets/less/reset.less";
import "./assets/css/common.css";
import * as echarts from "echarts";
import httpsRequest from "./request/http.js";
import { api,uploader } from "@/request/api";
import ViewUI from "view-design";
import "view-design/dist/styles/iview.css";
import { refreshHeaderToken } from "./utils/login";
import array from "./utils/extension/array";
import date from "./utils/extension/date";
import object from "./utils/extension/object";
import number from "./utils/extension/number";
import string from "./utils/extension/string";
import { Loading } from 'element-ui';
import "./utils/rem.js";
import { production } from "./request/config";
import notificationCenter from '@/utils/WxNotificationCenter'
array,date,object,number,string;
api.loading=Loading;
Vue.prototype.api = api;
var routerCache={};
Vue.prototype.routerCache=routerCache;
Vue.prototype.initTableCacheWithRoutere=function(vm){
  var cache=vm.routerCache[vm.$router.currentRoute.fullPath];
  console.log(vm.$router.currentRoute.fullPath,cache);
  if(!cache){
    cache={};
    vm.routerCache[vm.$router.currentRoute.fullPath]=cache;
  }
  vm.cache=cache;
  var tableparam=vm.$route.query.tableparam;
  var load=true;
  if(!tableparam){
    tableparam=vm.cache.tableparam;
    var tabledata=vm.cache.tabledata;
    var statisticsdata=vm.cache.statisticsdata;
    if(statisticsdata)vm.statisticsdata=statisticsdata;
    if(tabledata&&tabledata.length>0){
      vm.tabledata=tabledata;
      load=false;
    }
  }
  if(tableparam)Object.assign(vm.tableparam, tableparam);
  
  
  return load;
}
Vue.prototype.defaultTable=function(vm){
  vm.tabledata=[];
  vm.statisticsdata=[];
  var height=document.documentElement.clientHeight;
  vm.tableHeight=(height-330);
  vm.inited=true;
}
router.afterEach((to,from) => {
  var tocache=routerCache[to.fullPath];
  var fromcache=routerCache[from.fullPath];
  if(tocache){
    if(tocache.scrollTop){
      setTimeout(()=>{
          //页面渲染完成后，在滚动，位置才是正确的，所以加个延迟
          var wrapper=document.getElementsByClassName('el-table__body-wrapper');
          if(wrapper.length>0){
            wrapper[0].scrollTop=tocache.scrollTop;
          }
      },10)
    }
  }
  if(fromcache){
    var wrapper=document.getElementsByClassName('el-table__body-wrapper');
    if(wrapper.length>0){
      var scrollTop=wrapper[0].scrollTop*1;
      fromcache.scrollTop=scrollTop//储存位置
    }
  }
  
  console.log('afterEach',to,from);
 });

Vue.prototype.uploader = uploader;
Vue.prototype.$loading = Loading;
Vue.prototype.notificationCenter=notificationCenter;
var user={
    roleType:'',
    memberTypeMap:{
    1: "vip会员",
    2: "体验会员",
    3: "游客",
    },
    memberTypeE:{
    VIP:1,
    TRYVIP:2,
    YOUKE:3
    },
    doctorTypeE:{
      ZXS:"健康管理师",//
      TDD:"团队端",//xglasteamer
      JGD:"机构端", //xglhtteamer
      XTGLY:"系统管理员" , // 2 sysadmin
      CJYH:"超级用户"  // 2 sysadmin
    },
    sexMap:{
      0:'男',
      1:'女'
    },
    workStatusMap:[
      "在职",
      "离职"
    ],
    interfaceTypeMapE:{
      TEAM:0,
      HEALTH:1,
      DIET:2,
      PRECISE:3,
      WARNING:4,
      MSG:5,
      NURTRIENT:6,
      CONTACT:6
    },
    todoType:{
      WARNING:1,
      MSG:2,
      SYSTEM:3,
      SCHEME:4,
      DIET:5
    },
    commontTableMap:{
      
    },
    
};

user.isTDD= function () {
  return this.roleType === this.doctorTypeE.TDD;
};
user.isXTGLY= function () {
  return this.roleType === this.doctorTypeE.XTGLY;
};
user.isZXS= function () {
  return this.roleType === this.doctorTypeE.ZXS;
};
user.isJGD= function () {
  return this.roleType === this.doctorTypeE.JGD;
};


var tableHandle={
    statusMsgMap:{
      zsfa:{
        1: "待处理",
        2: "已处理",
        3: "转移给上级",
      },
      warning:{
        1: "待处理",
        2: "已处理",
        3: "转移给上级",
      },
      news:{
        1: "处理",
        2: "查看",
        3: "处理"
      },
      diet:{
        1: "处理",
        2: "查看",
        3: "处理"
      }
    },
    searchKeyTypes:{
      zsfa:[
        {label:"其他信息",value:'matchName',placeholder:"请输入客户id/客户所属咨询师/人群划分查询"}
      ],
      warning:[
        {label:"其他信息",value:'matchName',placeholder:"请输入客户id/客户所属咨询师/预警信息查询"}
      ],
      news:[
        {label:"其他信息",value:'matchName',placeholder:"请输入客户id/客户所属咨询师/消息内容查询"}
      ],
      diet:[
        {label:"其他信息",value:'matchName',placeholder:"请输入客户id/客户所属咨询师/解读内容查询"}
      ]
    },
    searchDateTypes:{
      zsfa:[
        {value:"yjsj",label:"预警时间",start:'startWarningTime',end:'endWarningTime'},
        {value:"yjclsj",label:"预警处理时间",start:'startWarningGenerateTime',end:'endWarningGenerateTime'}
      ],
      warning:[
        {value:"yjsj",label:"预警时间",start:'startWarningTime',end:'endWarningTime'},
        {value:"yjclsj",label:"预警处理时间",start:'startWarningGenerateTime',end:'endWarningGenerateTime'}
      ],
      news:[
        {value:"yjsj",label:"预警时间",start:'startWarningTime',end:'endWarningTime'},
        {value:"yjclsj",label:"预警处理时间",start:'startWarningGenerateTime',end:'endWarningGenerateTime'}
      ],
      diet:[
        {value:"yjsj",label:"预警时间",start:'startWarningTime',end:'endWarningTime'},
        {value:"yjclsj",label:"预警处理时间",start:'startWarningGenerateTime',end:'endWarningGenerateTime'}
      ]
    },
    actions:{
      zsfa:function(row){
        var actions=[];
        row.process={edit:false};
        var processActions=[];
        if(user.isZXS()){
          if(row.status==1){
            row.process.edit=true;
            actions.push({title:"处理",id:'handle',dot:1});
            processActions.push({title:"提交",id:'submit'});
            processActions.push({title:"申请业务帮助",id:'apply'});
            row.process.applyAlert='确定申请业务帮助吗？一旦申请业务帮助，在收到反馈之前当前遇见无法处理。';
          }
          else{
            actions.push({title:"查看",id:'detail'});
          }
        }
        else if(row.status==3&&row.transforId==user.basicInfo.id){
          row.process.edit=true;
          actions.push({title:"处理",id:'handle',dot:1});
          processActions.push({title:"提交",id:'submit'});
          if(!user.isXTGLY())
          processActions.push({title:"转交上级处理",id:'apply'});
          row.process.applyAlert='确定转交业务帮助吗？一旦转交业务帮助，您将无法处理。';
        }
        else{
          actions.push({title:"查看",id:'detail'});
        }
        row.process.actions=processActions;
        row.tableActions=actions;
      },
      warning:function(row){
        var actions=[];
        
        row.process={edit:false};
        var processActions=[];
        if(user.isZXS()){
          if(row.status==1){
            console.log(223);
            row.process.edit=true;
            actions.push({title:"处理",id:'handle',dot:1});
            processActions.push({title:"提交",id:'submit'});
            processActions.push({title:"申请业务帮助",id:'apply'});
            row.process.applyAlert='确定申请业务帮助吗？一旦申请业务帮助，在收到反馈之前当前遇见无法处理。';
          }
          else{
            actions.push({title:"查看",id:'detail'});
          }
        }
        else if(row.status==3&&row.transforId==user.basicInfo.id){
          row.process.edit=true;
          actions.push({title:"处理",id:'handle',dot:1});
          processActions.push({title:"提交",id:'submit'});
          if(!user.isXTGLY()){
            processActions.push({title:"转交上级处理",id:'apply'});
            row.process.applyAlert='确定转交业务帮助吗？一旦转交业务帮助，您将无法处理。';
          }
          
        }
        else{
          actions.push({title:"查看",id:'detail'});
        }
        row.process.actions=processActions;
        row.tableActions=actions;
      },
      news:function(row){
        var actions=[];
        if(1||row.status==1){
          actions.push({title:"处理",id:'handle',dot:1});
        }
        else{
          actions.push({title:"查看",id:'detail'});
        }
        row.tableActions=actions;
      },
      diet:function(row){
        var actions=[];
        if(1||row.status==1){
          actions.push({title:"处理",id:'handle',dot:1});
        }
        else{
          actions.push({title:"查看",id:'detail'});
        }
        row.tableActions=actions;
      }
    }
}
Vue.prototype.tableHandle = tableHandle;
Vue.prototype.user = user;
Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.use(ViewUI);
Vue.use(Viewer);
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(less);
Vue.prototype.$echarts = echarts;
Viewer.setDefaults({
  Options: {
    inline: true,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: "data-source",
  },
});
refreshHeaderToken(production);

// document.oncontextmenu=function(evt){
//   evt.preventDefault();
// }
//
// document.onselectstart=function(evt){
//  evt.preventDefault();
// };
new Vue({
  router,
  httpsRequest,
  render: (h) => h(App),
}).$mount("#app");




